// CampaignTableHeader.jsx
import React from 'react';

function TableHeader({ header }) {
    return (
        <thead>
            <tr>
                {header.map((element, index) => (
                    <th key={index}>{element}</th>
                ))}
            </tr>
        </thead>
    );
}

export default TableHeader;
